var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgContentHotFill(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M13.406 1.335s.694 2.485.694 4.5c0 1.932-1.266 3.498-3.197 3.498-1.94 0-3.403-1.566-3.403-3.497l.028-.338A12.91 12.91 0 004.5 13.834a7.499 7.499 0 007.5 7.501c4.144 0 7.5-3.357 7.5-7.501 0-5.054-2.428-9.564-6.094-12.499zm-1.678 17.187c-1.669 0-3.019-1.313-3.019-2.944 0-1.52.985-2.588 2.635-2.926 1.66-.337 3.375-1.134 4.331-2.419.366 1.21.553 2.485.553 3.788a4.502 4.502 0 01-4.5 4.501z",
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContentHotFill);
export default __webpack_public_path__ + "bbc6d1a19b5aa14f9d6759c4d9844da4.svg";
export { ForwardRef as ReactComponent };